import {InjectionToken} from '@angular/core'
import {XLSX$Utils} from 'xlsx'

/**
 * Defines and exports an injection token that replaces the browser
 * window object.
 */
export const WINDOW = new InjectionToken<Window>('window')

/**
 * Defines and exports an injection token that replaces the browser
 * window object.
 */
export const XLSX_PROVIDER = new InjectionToken<XLSX$Utils>('xlsx')


export const FileTypeSelect: FileTypeItem[] = [
  {
    value: '1',
    name: 'Lån'
  },
  {
    value: '2',
    name: 'Krediter och Byggnadskreditiv vid nyupplägg'
  },
  {
    value: '3',
    name: 'Krediter och Byggnadskreditiv vid höjning'
  },
  {
    value: '6',
    name: 'Generell säkerhet'
  },
  {
    value: '9',
    name: 'Kreditkort'
  },
  {
    value: '11',
    name: 'Villkorsförändring',
    digital: true
  },
  {
    value: '12',
    name: 'Villkorsförändring med bilaga',
    digital: true
  },
  {
    value: '13',
    name: 'Visa betal- och kreditkort',
    digital: true
  },
  {
    value: '14',
    name: 'Visa Business Card',
    digital: true
  }
]

export interface FileTypeItem {
  value: string
  name: string
  digital?: boolean
}